import _classCallCheck from "/home/runner/work/web/web/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/home/runner/work/web/web/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _assertThisInitialized from "/home/runner/work/web/web/node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js";
import _inherits from "/home/runner/work/web/web/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/home/runner/work/web/web/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/home/runner/work/web/web/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var __defProp = Object.defineProperty;

var __defNormalProp = function __defNormalProp(obj, key, value) {
  return key in obj ? __defProp(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};

var __publicField = function __publicField(obj, key, value) {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);

  return value;
};

var __accessCheck = function __accessCheck(obj, member, msg) {
  if (!member.has(obj)) throw TypeError("Cannot " + msg);
};

var __privateGet = function __privateGet(obj, member, getter) {
  __accessCheck(obj, member, "read from private field");

  return getter ? getter.call(obj) : member.get(obj);
};

var __privateAdd = function __privateAdd(obj, member, value) {
  if (member.has(obj)) throw TypeError("Cannot add the same private member more than once");
  member instanceof WeakSet ? member.add(obj) : member.set(obj, value);
};

var __privateSet = function __privateSet(obj, member, value, setter) {
  __accessCheck(obj, member, "write to private field");

  setter ? setter.call(obj, value) : member.set(obj, value);
  return value;
};

var _mediaController, _clickListener, _keyupListener, _keydownListener;

import { MediaStateReceiverAttributes } from "./constants.js";
import { getOrInsertCSSRule } from "./utils/element-utils.js";
import { globalThis, document } from "./utils/server-safe-globals.js";
var template = document.createElement("template");
template.innerHTML = "\n<style>\n  :host {\n    font: var(--media-font,\n      var(--media-font-weight, bold)\n      var(--media-font-size, 14px) /\n      var(--media-text-content-height, var(--media-control-height, 24px))\n      var(--media-font-family, helvetica neue, segoe ui, roboto, arial, sans-serif));\n    color: var(--media-text-color, var(--media-primary-color, rgb(238 238 238)));\n    background: var(--media-control-background, var(--media-secondary-color, rgb(20 20 30 / .7)));\n    padding: var(--media-control-padding, 10px);\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    vertical-align: middle;\n    box-sizing: border-box;\n    transition: background .15s linear;\n    pointer-events: auto;\n    cursor: pointer;\n    -webkit-tap-highlight-color: transparent;\n  }\n\n  ".concat("\n  :host(:focus-visible) {\n    box-shadow: inset 0 0 0 2px rgb(27 127 204 / .9);\n    outline: 0;\n  }\n  ", "\n  :host(:where(:focus)) {\n    box-shadow: none;\n    outline: 0;\n  }\n\n  :host(:hover) {\n    background: var(--media-control-hover-background, rgba(50 50 70 / .7));\n  }\n\n  svg, img, ::slotted(svg), ::slotted(img) {\n    width: var(--media-button-icon-width);\n    height: var(--media-button-icon-height, var(--media-control-height, 24px));\n    transform: var(--media-button-icon-transform);\n    transition: var(--media-button-icon-transition);\n    fill: var(--media-icon-color, var(--media-primary-color, rgb(238 238 238)));\n    vertical-align: middle;\n    max-width: 100%;\n    max-height: 100%;\n    min-width: 100%;\n  }\n</style>\n");

var MediaChromeButton = /*#__PURE__*/function (_globalThis$HTMLEleme) {
  _inherits(MediaChromeButton, _globalThis$HTMLEleme);

  var _super = _createSuper(MediaChromeButton);

  function MediaChromeButton() {
    var _this;

    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, MediaChromeButton);

    _this = _super.call(this);

    __privateAdd(_assertThisInitialized(_this), _mediaController, void 0);

    __publicField(_assertThisInitialized(_this), "preventClick", false);

    __privateAdd(_assertThisInitialized(_this), _clickListener, function (e) {
      if (!_this.preventClick) {
        _this.handleClick(e);
      }
    });

    __privateAdd(_assertThisInitialized(_this), _keyupListener, function (e) {
      var key = e.key;

      if (!_this.keysUsed.includes(key)) {
        _this.removeEventListener("keyup", __privateGet(_assertThisInitialized(_this), _keyupListener));

        return;
      }

      if (!_this.preventClick) {
        _this.handleClick(e);
      }
    });

    __privateAdd(_assertThisInitialized(_this), _keydownListener, function (e) {
      var metaKey = e.metaKey,
          altKey = e.altKey,
          key = e.key;

      if (metaKey || altKey || !_this.keysUsed.includes(key)) {
        _this.removeEventListener("keyup", __privateGet(_assertThisInitialized(_this), _keyupListener));

        return;
      }

      _this.addEventListener("keyup", __privateGet(_assertThisInitialized(_this), _keyupListener), {
        once: true
      });
    });

    if (!_this.shadowRoot) {
      _this.attachShadow({
        mode: "open"
      });

      var buttonHTML = template.content.cloneNode(true);
      _this.nativeEl = buttonHTML;
      var slotTemplate = options.slotTemplate;

      if (!slotTemplate) {
        slotTemplate = document.createElement("template");
        slotTemplate.innerHTML = "<slot>".concat(options.defaultContent || "", "</slot>");
      }

      _this.nativeEl.appendChild(slotTemplate.content.cloneNode(true));

      _this.shadowRoot.appendChild(buttonHTML);
    }

    var _getOrInsertCSSRule = getOrInsertCSSRule(_this.shadowRoot, ":host"),
        style = _getOrInsertCSSRule.style;

    style.setProperty("display", "var(--media-control-display, var(--".concat(_this.localName, "-display, inline-flex))"));
    return _this;
  }

  _createClass(MediaChromeButton, [{
    key: "enable",
    value: function enable() {
      this.addEventListener("click", __privateGet(this, _clickListener));
      this.addEventListener("keydown", __privateGet(this, _keydownListener));
      this.tabIndex = 0;
    }
  }, {
    key: "disable",
    value: function disable() {
      this.removeEventListener("click", __privateGet(this, _clickListener));
      this.removeEventListener("keydown", __privateGet(this, _keydownListener));
      this.removeEventListener("keyup", __privateGet(this, _keyupListener));
      this.tabIndex = -1;
    }
  }, {
    key: "attributeChangedCallback",
    value: function attributeChangedCallback(attrName, oldValue, newValue) {
      var _a, _b, _c, _d, _e;

      if (attrName === MediaStateReceiverAttributes.MEDIA_CONTROLLER) {
        if (oldValue) {
          (_b = (_a = __privateGet(this, _mediaController)) == null ? void 0 : _a.unassociateElement) == null ? void 0 : _b.call(_a, this);

          __privateSet(this, _mediaController, null);
        }

        if (newValue && this.isConnected) {
          __privateSet(this, _mediaController, (_c = this.getRootNode()) == null ? void 0 : _c.getElementById(newValue));

          (_e = (_d = __privateGet(this, _mediaController)) == null ? void 0 : _d.associateElement) == null ? void 0 : _e.call(_d, this);
        }
      } else if (attrName === "disabled" && newValue !== oldValue) {
        if (newValue == null) {
          this.enable();
        } else {
          this.disable();
        }
      }
    }
  }, {
    key: "connectedCallback",
    value: function connectedCallback() {
      var _a, _b, _c;

      if (!this.hasAttribute("disabled")) {
        this.enable();
      }

      this.setAttribute("role", "button");
      var mediaControllerId = this.getAttribute(MediaStateReceiverAttributes.MEDIA_CONTROLLER);

      if (mediaControllerId) {
        __privateSet(this, _mediaController, (_a = this.getRootNode()) == null ? void 0 : _a.getElementById(mediaControllerId));

        (_c = (_b = __privateGet(this, _mediaController)) == null ? void 0 : _b.associateElement) == null ? void 0 : _c.call(_b, this);
      }
    }
  }, {
    key: "disconnectedCallback",
    value: function disconnectedCallback() {
      var _a, _b;

      this.disable();
      (_b = (_a = __privateGet(this, _mediaController)) == null ? void 0 : _a.unassociateElement) == null ? void 0 : _b.call(_a, this);

      __privateSet(this, _mediaController, null);
    }
  }, {
    key: "keysUsed",
    get: function get() {
      return ["Enter", " "];
    }
  }, {
    key: "handleClick",
    value: function handleClick(e) {}
  }], [{
    key: "observedAttributes",
    get: function get() {
      return ["disabled", MediaStateReceiverAttributes.MEDIA_CONTROLLER];
    }
  }]);

  return MediaChromeButton;
}(globalThis.HTMLElement);

_mediaController = new WeakMap();
_clickListener = new WeakMap();
_keyupListener = new WeakMap();
_keydownListener = new WeakMap();

if (!globalThis.customElements.get("media-chrome-button")) {
  globalThis.customElements.define("media-chrome-button", MediaChromeButton);
}

var media_chrome_button_default = MediaChromeButton;
export { MediaChromeButton, media_chrome_button_default as default };